import { m } from 'motion/react';
import { containerVariants, viewPort } from '../../../utils/framer';
import FaqBlock from '../../components/FaqBlock';
import { AppStoreIcon } from '../../components/rentAndShare/AppStoreIcon';
import BoxesWithLines from '../../components/rentAndShare/BoxesWithLines';
import { ContentTextBox } from '../../components/rentAndShare/ContentTextBox';
import { GooglePlayIcon } from '../../components/rentAndShare/GooglePlayIcon';
import { GreyBox } from '../../components/rentAndShare/Greybox';
import { InternalLink } from '../../components/rentAndShare/InternalLink';
import { LinkApp } from '../../components/rentAndShare/LinkApp';
import { Testimony } from '../../components/rentAndShare/Testimony';
import { TwoFlexibleComponentBox } from '../../components/rentAndShare/TwoFlexibleComponentBox';
import { VideoClip } from '../../components/rentAndShare/VideoClip';
import Snippet from '../../components/Snippet';
import KIAImage from '../../components/ui/image/KIAImage';

const RentAndShareLanding = () => {
  return (
    <main>
      <VideoClip
        title="Kia Drive"
        subTitle="Hyr & Dela"
        autoplay
        src="https://kia-afonso-storage.b-cdn.net/filmer/HyrDela-Hero-Clean-EV3-appsida.mp4"
      />
      <div className="max-w-screen-xl mx-auto">
        <BoxesWithLines
          boxes={[
            {
              title: 'HYR',
              text: 'Hyr er nästa företagsbil månadsvis.',
              boxColor: 'bg-gray-100',
            },
            {
              title: 'DELA',
              text: 'Anslut till tjänsten Kia Drive och gör bilen bokningsbar per timme.',
              boxColor: 'bg-gray-100',
            },
            {
              title: 'ANVÄND',
              text: 'All administration och användning sköts via appen.',
              boxColor: 'bg-gray-100',
            },
          ]}
          lineColor="bg-gray-100"
        />
        <section>
          <TwoFlexibleComponentBox
            firstComponent={
              <ContentTextBox
                title="Så fungerar Kia Drive"
                description="Hyr en företagsbil som alla tjänar på. Med vår bildelningsapp Kia Drive kan ni dela er företagsbil med anställda eller gäster under dygnets alla timmar. Ni slipper manuell nyckelhantering och fakturering, och era användare kan enkelt boka och låsa upp bilen via appen. Anslut via er återförsäljare och kom i gång redan idag."
              >
                <InternalLink
                  text="Läs mer om appen"
                  href="https://www.kia.com/se/kopa/hyr-och-dela/hyr-och-dela-app"
                />
                <div className="flex gap-4 mt-10">
                  <LinkApp
                    text="Google Play"
                    Icon={GooglePlayIcon}
                    href="https://play.google.com/store/apps/details?id=com.ridecell.massiv.kangaroo.prod&hl=en"
                    target="_blank"
                  />
                  <LinkApp
                    text="App Store"
                    Icon={AppStoreIcon}
                    href="https://apps.apple.com/se/app/hyr-dela/id1658798260"
                    target="_blank"
                  />
                </div>
              </ContentTextBox>
            }
            secondComponent={
              <KIAImage
                src="https://kia-afonso-storage.b-cdn.net/Handbild-Iphone-HyrDela.png"
                alt="KIA Car"
                sizes="(max-width: 768px) 50vw, 100vw"
                className="object-cover object-center w-[50%] h-auto mx-auto lg:w-full"
              />
            }
            mobilFirstComponentOnTop={false}
            desktopFirstComponentFirst={false}
            firstComponentWidth="lg:col-span-5"
            secondComponentWidth="lg:col-span-3"
          />
        </section>
        <section>
          <GreyBox
            boxes={[
              {
                title: 'Upptäck vår laddbara frihet',
                text: 'Njut av den senaste tekniken och oslagbar frihetskänsla med våra laddbara bilar.',
              },
              {
                title: 'Enkel administration',
                text: 'Säg hejdå till manuell nyckelhantering och bokning.',
              },
              {
                title: 'All inclusive - om ni vill',
                text: 'Ta del av våra fullservicelösningar för service och underhåll.',
              },
              {
                title: 'Frihet direkt i fickan',
                text: 'Boka, öppna, starta, kör - direkt via appen.',
              },
              {
                title: 'Smart oavsett verksamhet',
                text: 'Från camping till kontor och verkstad. Kia Drive går att använda i alla slags verksamheter.',
              },
              {
                title: 'Kundsupport dygnet runt',
                text: 'Vår förarsupport är tillgänglig dygnet runt på 0770-11 70 00.',
              },
            ]}
          />
        </section>
        <m.section
          initial="hidden"
          whileInView="visible"
          viewport={viewPort}
          variants={containerVariants}
          className="w-full lg:grid-cols-2 grid"
        >
          <Testimony
            imageSrc="https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/campaigns/hyr-och-dela/Bylunds-logo.png"
            altText="Hanna Bylund"
            name="Hanna Bylund"
            title="Bylunds Bil"
            testimony="”Vi använder Kia Drive för våra verkstadsbilar. De kunder som redan kör elbil och är mer digitala, tycker att det är kul att ladda ner en app för att välja lånebil. Men det är nästan ännu roligare när vi når de kunder som inte är lika digitala, utan till och med lite rädda för att testa elbil. När lånetiden är slut och de ska byta tillbaka till sin vanliga bil säger nästan alla att de hellre behåller lånebilen.”"
          />
          <Testimony
            imageSrc="https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/campaigns/hyr-och-dela/skill-logo.png"
            altText="Marie Karlsson"
            name="Marie Karlsson"
            title="Kontorskoordinator Skill"
            testimony="”För oss som rekryterings- och bemanningsföretag är en egen bilflotta nödvändig och att kunna optimera den efter behov och kostnad är ovärderligt. Med Kia Drive får vi den flexibiliteten samtidigt som vi kan erbjuda våra medarbetare ett cirkulärt alternativ till att äga bil. Vårt nästa steg är att se över vår nuvarande bilfotta och kanske knacka på hos våra kontorsgrannar och fråga om de vill vara med och dela på vår nästa bil.”"
          />
        </m.section>

        <FaqBlock
          title="Vanliga frågor och svar om Kia Drive"
          questions={[
            {
              q: 'Hur ser betalningsmodellen ut?',
              a: 'Som företag kan ni hyra en eller flera bilar månadsvis och har sedan möjlighet att dela bilen/bilarna med anställda eller gäster under dygnets alla timmar. Ni betalar för bilen per månad och de som använder bilen betalar för sin användning direkt i appen Kia Drive.',
            },
            {
              q: 'Vad händer om det sker en olycka?',
              a: 'Bilarna är fullt försäkrade. Om olyckan skulle vara framme gäller självrisk enligt hyresavtalet.',
            },
            {
              q: 'Hur får användarna tillgång till bilen?',
              a: "Appen fungerar som en nyckel till bilen. Några minuter innan hyresperioden börjar skickas ett sms till det mobilnummer som användaren uppgett, och bilen aktiveras samtidigt i appen Kia Drive. Genom att trycka på 'Lås upp och starta' i appen låser användaren enkelt upp bilen och har sedan två minuter på sig att starta bilen. Om föraren inte hinner starta bilen under den tiden kan hen alltid trycka på 'Lås upp och starta' i appen igen.",
            },
            {
              q: 'Vem tar hand om bilen?',
              a: "Ni kan välja om ni som företag tar ansvar för allt som rör bilen, precis som en traditionell tjänstebil, eller om ni önskar en fullservicelösning. Prata med er <a href='https://www.kia.com/se/sok-aterforsaljare-verkstad/#/' target='_blank'>Kia-återförsäljare</a> för att hitta en lösning skräddarsydd för just era behov.",
            },
          ]}
        />
      </div>

      <Snippet page="rent-landing" />
    </main>
  );
};
export default RentAndShareLanding;
